import React, { useEffect, useState } from "react";
import SeoHelmet from "@/components/SeoHelmet";
import seoConfig from "@/data/seo.config";
// import "../../src/styles/frontend/lightbox/lightboxstyle.css";
import "@/styles/frontend/lightbox/lightboxstyle.css";
import fjGallery from "flickr-justified-gallery";

import LightGallery from "lightgallery/react";
// import lgZoom from "lightgallery/plugins/zoom";
// import lgVideo from "lightgallery/plugins/video";

import { useDispatch, useSelector } from "react-redux";
import { fetchGalleryImages } from "@/store/modern/slices/newsAndEventSlice";
import ConsentManager from "@/modules/frontend/components/ConsentManager";

import MobBanner from "@/assets/images/webp/event-mobile-banner.webp";

const Index = () => {
  //   const [allImages, setAllImages] = useState(null);
  //   const [imageAvailable, setImageAvailable] = useState(false);

  const dispatch = useDispatch();

  // grab gallery images state
  const galleryImages = useSelector((state) => state.galleryImages) || {};
  const { list: allImages = { iics_expo: [], vietnam: [], conference_dubai: [], gulfood: [], conference: [] } } = galleryImages;

  useEffect(() => {
    if (allImages && (allImages.iics_expo?.length || allImages.vietnam?.length || allImages.conference_dubai?.length)) {
      fjGallery(document.querySelectorAll(".gallery"), {
        itemSelector: ".gallery__item",
        rowHeight: 320,
        lastRow: "start",
        gutter: 16,
        rowHeightTolerance: 0.1,
        calculateItemsHeight: true,
      });
    }
  }, [allImages]);

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }, []);

  useEffect(() => {
    dispatch(fetchGalleryImages());
  }, []);

  //   const fetchImages = async () => {
  //     await axios
  //       .get(API_URL + "/image-gallery")
  //       .then((response) => {
  //         if (response.status === 200) {
  //           if (response.data.status === true) {
  //             setAllImages(response.data.data);
  //             setImageAvailable(true);
  //           }
  //         }
  //       })
  //       .catch((err) => {
  //         console.log("Error ========== ", err);
  //       });
  //   };

  //   useEffect(() => {
  //     fetchImages();
  //   }, []);

  return (
    <section className="gallery-wraper event-page">
      <SeoHelmet
        title={seoConfig.eventHighlights.title}
        description={seoConfig.eventHighlights.description}
        keywords={seoConfig.eventHighlights.keywords}
        author={seoConfig.eventHighlights.author}
      />
      {/* inner banner wrape START  */}
      <div className="inner-banner">
        {/* <div className="container">
          <div className="content-wrape desk-hide">
            <h2>
              <span className="light">Event </span>
              <span className="blue"> Highlights</span>
            </h2>
            <p>Join us to explore, learn and connect at our latest events.</p>
          </div>
        </div> */}

        <img src={MobBanner} alt="" className="mob-banner" />
      </div>
      {/* inner banner wrape END  */}

      <div className="image-gallery-wrape">
        {/* <div className=" inner-page-content-wrape p-0">
          <div className="content-wrape mobile-show page-head ">
            <h2 className="mobile-head-text">
              <span className="light">Event </span>
              <span className="blue-text"> Highlights</span>
            </h2>
            <p>Join us to explore, learn and connect at our latest events.</p>
          </div>
        </div> */}

        <div className="head-text center container medium">
          <h2 className="head center">
            <span>Showcase of</span> Excellence
          </h2>
          <p className="text">
            Discover the energy of our past events in the Event Gallery from trade fairs to networking sessions where members connect, collaborate and grow their business globally.
          </p>
        </div>

        {allImages && (
          <LightGallery
            //plugins={[lgZoom, lgVideo]}
            mode="lg-fade"
            pager={false}
            thumbnail={true}
            galleryId={"nature"}
            autoplayFirstVideo={false}
            elementClassNames={"gallery"}
            mobileSettings={{
              controls: false,
              showCloseIcon: false,
              download: false,
              rotate: false,
            }}
          >
            {allImages &&
              allImages.iics_expo.map((gImg) => {
                return (
                  <div
                    data-pinterest-text="Pin it2"
                    data-tweet-text="lightGallery slide  2"
                    className="gallery__item"
                    data-src={gImg.image}
                    data-sub-html="<h4>IICS Expo 2026</h4>"
                  >
                    <a
                      data-pinterest-text="Pin it2"
                      data-tweet-text="lightGallery slide  2"
                      data-src={gImg.image}
                      data-sub-html="<h4>Mumbai Expo 20265</h4>"
                      title="Event Highlights"
                    >
                      <img className="img-responsive" src={gImg.image} alt="Event Highlights" />
                    </a>
                  </div>
                );
              })}

            {allImages &&
              allImages.vietnam.map((conImg) => {
                return (
                  <div
                    data-pinterest-text="Pin it2"
                    data-tweet-text="lightGallery slide  2"
                    className="gallery__item"
                    data-src={conImg.image}
                    data-sub-html="<h4>Vietnam 2025</h4>"
                  >
                    <a
                      data-pinterest-text="Pin it2"
                      data-tweet-text="lightGallery slide  2"
                      //className="gallery__item1"
                      data-src={conImg.image}
                      data-sub-html="<h4>Vietnam 2025</h4>"
                      title="Event Highlights"
                    >
                      <img className="img-responsive" src={conImg.image} alt="Event Highlights" />
                    </a>
                  </div>
                );
              })}

            {allImages &&
              allImages.conference_dubai.map((conImg) => {
                return (
                  <div
                    data-pinterest-text="Pin it2"
                    data-tweet-text="lightGallery slide  2"
                    className="gallery__item"
                    data-src={conImg.image}
                    data-sub-html="<h4>Conference Dubai 2025</h4>"
                  >
                    <a
                      data-pinterest-text="Pin it2"
                      data-tweet-text="lightGallery slide  2"
                      //className="gallery__item1"
                      data-src={conImg.image}
                      data-sub-html="<h4>Conference Dubai 2025</h4>"
                      title="Event Highlights"
                    >
                      <img className="img-responsive" src={conImg.image} alt="Event Highlights" />
                    </a>
                  </div>
                );
              })}
          </LightGallery>
        )}
      </div>
      <ConsentManager data={""} />
    </section>
  );
}

export default Index;
